import React, { Component } from "react";

import { Metric } from "components/Utils/Utils.js";
import Heading from "components/Elements/Heading";

class LeeBreakoutSummary extends Component {
  render() {
    const { data } = this.props;

    return (
      <div className="row mt-2">
        {data.data.Google && (
          <div className="col mb-3 mb-sm-0">
            <Heading size={6} className={"mb-1"}>
              Google
            </Heading>

            <div className="d-flex">
              <Metric {...data.data.Google} size={"lg"} format={"%"} />
            </div>

            <div className="d-flex justify-content-left align-items-center">
              <h6 className="mb-0 mr-2">Broken out</h6>
              <Metric
                value={data.data.Google.absolute}
                size={"xs"}
                format={"%"}
              />
            </div>
          </div>
        )}

        {data.data.Apple && (
          <div className="col mb-3 mb-sm-0">
            <Heading size={6} className={"mb-1"}>
              Apple
            </Heading>

            <div className="d-flex">
              <Metric {...data.data.Apple} size={"lg"} format={"%"} />
            </div>

            <div className="d-flex justify-content-left align-items-center">
              <h6 className="mb-0 mr-2">Broken out</h6>
              <Metric
                value={data.data.Apple.absolute}
                size={"xs"}
                format={"%"}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default LeeBreakoutSummary;
